export const BACK_URL = 'https://auth.cricketbettingguru.net';
export const WP_API_URL = `${window.location.protocol}//${window.location.host}/wp-admin/admin-ajax.php`;
// export const BACK_URL = 'https://staging-auth.sportscafe.in';

export const STATE_MAP = {
    auth: {
        0: 'AuthForm',
        1: 'AuthRestore',
        2: 'AuthMessage',
        3: 'AuthRestore',
        5: 'AuthMessage',
        6: 'AuthMessage', // success verify
    },
    account: {
        1: 'AccountSettings',
        2: 'AccountPassword',
        5: 'AuthMessage',
    }
}

export const GENDERS = [
    { name: 'Prefer not to say', code: 'None' },
    { name: 'Male', code: 'Male' },
    { name: 'Female', code: 'Female' },
];

export const DEFAULT_STATE = {
    isOpen: true,
    isAuth: false,
    step: 0,
    userData: {},
}
